import type { PropsWithChildren } from "react";

import { tw } from "~/utils";

interface TextProps {
  className?: string;
}

export const Text = ({ className, children }: PropsWithChildren<TextProps>) => (
  <p className={tw("align-middle text-sm text-neutral-600", className)}>
    {children}
  </p>
);
